import styles from './InfoCard.module.css';

const InfoCard = ({ icon, text }) => {
  return (
    <div className={styles.card}>
      <div className={styles.iconChip}>
        {icon}
      </div>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default InfoCard;
